module.exports = __webpack_public_path__ + "405960d658189c55eb1421ed0d409f67.png";